import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence "Script error." noise from cross-origin TradingView iframes
// (installed BEFORE React dev overlay so it captures first)
if (typeof window !== "undefined") {
  const isNoise = (msg, filename) => {
    if (!msg) return false;
    const s = String(msg);
    return (
      s === "Script error." ||
      s.startsWith("ResizeObserver loop") ||
      (typeof filename === "string" && filename.includes("tradingview"))
    );
  };
  window.addEventListener(
    "error",
    (e) => {
      if (isNoise(e?.message, e?.filename)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );
  window.addEventListener("unhandledrejection", (e) => {
    if (isNoise(String(e?.reason?.message || e?.reason || ""), "")) e.preventDefault();
  });
  // Fully disable CRA's dev-only runtime error overlay.
  // Rationale: TradingView embed scripts throw cross-origin "Script error." events
  // that browsers strip of any useful info. The overlay catches these and
  // renders a huge red "Uncaught runtime errors" panel over the kiosk view
  // which frightens the user and blocks the whole TV Display. Real bugs still
  // print to console; production builds don't include react-error-overlay at all.
  try {
    // eslint-disable-next-line global-require
    const overlay = require("react-error-overlay");
    if (overlay?.stopReportingRuntimeErrors) overlay.stopReportingRuntimeErrors();
    if (overlay?.dismissRuntimeErrors) overlay.dismissRuntimeErrors();
  } catch (_) {
    /* react-error-overlay not present in prod build */
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
